// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2sffb","content":"LoadingAlert_content__3Brym"};